import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"

import veProgress from "vue-ellipse-progress";
import SimpleTypeahead from 'vue3-simple-typeahead';

import "@/assets/scss/app.scss"

createApp(App)
    .use(router)
    .use(store)
    .use(veProgress)
    .use(SimpleTypeahead)
    .mount("#app");
